import React from "react";

import TaxRatesPage from "../TaxRates/TaxRatesPage";
import { TAX_RATES_STATE_CONFIG } from "../TaxRates/configs";

// Tributos Estaduais (PO1-2729): wrapper fino da página compartilhada de Tributos.
const TaxRatesState = () => <TaxRatesPage {...TAX_RATES_STATE_CONFIG} />;

export default TaxRatesState;
